import { css } from '@firebolt-dev/css'
import { useMemo, useRef, useState } from 'react'

import { preloadInterfaces } from '../../shared/interfaces'
import { GameContent } from './GameContent'
import { GameDisconnected } from './GameDisconnected'

preloadInterfaces()

export function Game() {
  const [disconnected, setDisconnected] = useState(false)
  const elemRef = useRef()
  const size = useMemo(() => {
    if (window.navigator?.standalone) {
      return {
        width: '100vw',
        height: '100vh',
      }
    } else {
      return {
        width: '100dvw',
        height: '100dvh',
      }
    }
  }, [])

  return (
    <div
      ref={elemRef}
      css={css`
        position: relative;
        width: ${size.width};
        height: ${size.height};
        overflow: hidden;
        user-select: none;
      `}
    >
      {disconnected && <GameDisconnected setDisconnected={setDisconnected} />}
      {!disconnected && <GameContent setDisconnected={setDisconnected} />}
    </div>
  )
}
